// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__DvMQZ","header":"MessagesList_header__25eTK","chat":"MessagesList_chat__g5MJv"};